export default "__VITE_ASSET__D90Alkvg__"